import { GoogleLogin } from '@react-oauth/google';
import { toast } from "react-toastify";
import BuilderService from "../../services/BuilderService"; 
import { useNavigate } from 'react-router-dom';

const GoogleLoginButton = () => {
  const navigate = useNavigate();
  const builderService = new BuilderService();

  const handleGoogleLogin = async (credential: string) => {
    console.log("Received credential in handleGoogleLogin:", credential);
    if (!credential) {
      return toast.error("Google authentication failed. No credential received.");
    }

    try {
      const res = await builderService.loginWithGoogle(credential);
      console.log("Backend Response:", res);
      if (res.success) {
        await new Promise((r)=>setTimeout(r,500));
         const sessionValid = await builderService
          .checkSessionValidity()
   
          .then((r) =>{
            return r?.data?.exists === true
          })
          .catch((err) => {
            console.error('Session invalid:', err);
            return false;
          });

        if (!sessionValid) {
          toast.warn('Third-party cookies are blocked. Please enable them to continue.');
          return;
        }

        toast.success('Google login successful!');
        navigate('/');  // Redirect to home after login
      }
    } catch (err: any) {
      console.error('Google login failed:', err);
      toast.error(err?.response?.data?.message || 'Google login failed');
    }
  };

  return (
    <div className='w-full' onClick={(e) => e.preventDefault()}>
      <button 
        className="w-full flex items-center google-button justify-center gap-3 px-4 py-2.5 rounded-md transition-colors"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const googleLoginButton = document.querySelector('.hidden-google-btn [role="button"]');
          if (googleLoginButton instanceof HTMLElement) {
            googleLoginButton.click();
          }
        }}
      >
        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
          <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
          <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
          <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
        </svg>
        <span style={{fontWeight:400}} className="text-[14px] font-sora google-btn-color">
          Continue with Google
        </span>
      </button>
      <div className="hidden-google-btn" style={{ display: 'none' }}>
        <GoogleLogin
          type="standard"
          text="signin_with"
          shape="rectangular"
          theme="outline"
          size="large"
          width="100%"
          useOneTap={false}
          onSuccess={(response) => {
            console.log("Google Login Response:", response);
            if (response.credential) {
              handleGoogleLogin(response.credential);
            } else {
              toast.error("Google authentication failed. No credential received.");
            }
          }}
          onError={() => {
            toast.error("Google login failed");
          }}
        />
      </div>
    </div>
  );
};

export default GoogleLoginButton;
